type UrlConfigProps = {
  clientAccountingUrl: string
  clientAuthUrl: string
  clientCompaniesUrl: string
  companiesApiUrl: string
}

export const UrlConfig: UrlConfigProps = {
  clientAccountingUrl: import.meta.env.VITE_CLIENT_ACCOUNTING_URL ?? 'http://localhost:5374',
  clientAuthUrl: import.meta.env.VITE_CLIENT_AUTH_URL ?? 'http://localhost:5376',
  clientCompaniesUrl: import.meta.env.VITE_CLIENT_COMPANIES_URL ?? 'http://localhost:5375',
  companiesApiUrl: import.meta.env.VITE_COMPANIES_API_URL ?? 'http://localhost:3337',
}
